{
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "sectionSettings": "الإعدادات",
    "settings": "الإعدادات",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "toggleSidebarHint": "تبديل الشريط الجانبي",
    "deposits": "الأمانات",
    "newDeposit": "إيداع أمانة",
    "deliver": "تسليم أمانة",
    "reports": "التقارير",
    "currencies": "العملات",
    "depositSettings": "إعدادات الأمانات",
    "reportHeld": "الأمانات المحتفظ بها",
    "reportDelivered": "الأمانات المسلمة",
    "reportDetailed": "كشف تفصيلي",
    "reportByCustomer": "حسب العميل",
    "reportByEmployee": "حسب الموظف"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "toggleHint": "إظهار أو إخفاء القائمة",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "brand": "المسافر"
}
